(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk8cult-banner"] && !Shopify.designMode) return;
  try {
    
  const banners = document.querySelectorAll('.sk8cult-banner[data-feed-url]');

  banners.forEach(async (banner) => {
    const feedUrl = banner.dataset.feedUrl;
    const feed = banner.querySelector('[data-sk8cult-banner-feed]');
    const count = Number(banner.dataset.feedCount || 0);

    if (!feedUrl || !feed || !count) return;

    try {
      const response = await fetch(feedUrl, { credentials: 'same-origin' });
      if (!response.ok) return;

      const payload = await response.json();
      const items = Array.isArray(payload) ? payload : payload.images || payload.media || payload.data || [];
      const images = items
        .map((item) => ({
          src: item.image || item.image_url || item.media_url || item.thumbnail_url || item.url,
          alt: item.alt || item.caption || '',
        }))
        .filter((item) => item.src)
        .slice(0, count);

      if (!images.length) return;

      feed.replaceChildren(
        ...images.map((item) => {
          const wrapper = document.createElement('div');
          const image = document.createElement('img');

          wrapper.className = 'sk8cult-banner__feed-item';
          image.className = 'sk8cult-banner__feed-image';
          image.src = item.src;
          image.alt = item.alt;
          image.loading = 'lazy';

          wrapper.append(image);
          return wrapper;
        })
      );
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk8cult-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sk8cult-reviews]';

    const initReviews = (container) => {
      if (container.dataset.sk8cultReviewsInitialized === 'true') return;

      const list = container.querySelector('[data-sk8cult-reviews-list]');
      const previous = container.querySelector('[data-sk8cult-reviews-previous]');
      const next = container.querySelector('[data-sk8cult-reviews-next]');

      if (!list || !previous || !next) return;

      const getScrollDistance = () => {
        const firstCard = list.firstElementChild;
        if (!firstCard) return list.clientWidth;

        const styles = window.getComputedStyle(list);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const cardWidth = firstCard.getBoundingClientRect().width + gap;

        if (!cardWidth) return list.clientWidth;

        return cardWidth * Math.max(1, Math.floor(list.clientWidth / cardWidth));
      };

      const updateControls = () => {
        const maxScroll = list.scrollWidth - list.clientWidth - 1;
        previous.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= maxScroll;
      };

      previous.addEventListener('click', () => {
        list.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        list.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
      });

      list.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);

      container.dataset.sk8cultReviewsInitialized = 'true';
      updateControls();
    };

    const initAllReviews = (root = document) => {
      root.querySelectorAll(selector).forEach(initReviews);
    };

    initAllReviews();
    document.addEventListener('DOMContentLoaded', () => initAllReviews());
    document.addEventListener('shopify:section:load', (event) => initAllReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
